import React, { useState, useEffect } from 'react';
import { CssBaseline, Grid, Typography } from '@material-ui/core';
import { Tab, Tabs, Paper, Box, AppBar } from '@material-ui/core';
import { AccountCircle, Create } from '@material-ui/icons';
import { useStyles } from '../styles/SignInSide';
import 'fontsource-roboto';
import { Login } from '../components/login/Login';
import { Register } from '../components/login/Register';
import { Copyright } from '../components/utils/Copyright'
import { SignaMedLogo } from '../components/utils/SignaMedLogo';
import { SignaMedName } from '../components/utils/SignaMedName';
import { pLoginTab } from "../utils/parameters";
import { useLocation } from "react-router-dom";
import "../styles/devices/mob_Signin.css";
import { useTranslation } from "react-i18next";
/*import { phoneDetected } from '../api/utils/device';*/

/* Login/Register page */
export function SignInSide() {
    const { t } = useTranslation("global")

    /* MOB - PHONE DETECTION */
    /* Check - 'const + useState' vs 'let + useEffect' */
    /*const [isPhone, setIsPhone] = useState(phoneDetected);*/
    const styles = useStyles();

    /* Tabs */
    const [tabValue, setTabValue] = useState(0);
    function handleTabChange(event, newValue) {
        setTabValue(newValue);
    };

    const location = useLocation();
    useEffect(() => {
        console.log('SIGNINSIDE: ', location)
        if (location.loginTab !== undefined){
            setTabValue(location.loginTab);
        }
    }, [location]);
    
    return (
        <Grid container component="main" className="sig_SignIn_Root">
            <CssBaseline />
            <Grid item xs={false} sm={false} md={6} lg={7} className={styles.image} />
            <Grid className="sig_SignIn_FlexColumnContainer" item xs={12} sm={12} md={6} lg={5} component={Paper} elevation={6} square>
                <AppBar className={styles.appbar} position='sticky'>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        centered  >
                        <Tab className="sig_SignIn_Tab" icon={<AccountCircle />} label="Login" />
                        <Tab className="sig_SignIn_Tab" icon={<Create />} label="Registro" />
                    </Tabs>
                </AppBar>
                <div className="sig_SignIn_SignInOptionsContainer">
                    <Grid container className="sig_SignIn_SignInOptions" spacing={1} direction='column' alignItems='center'>
                        <Grid item>
                            <SignaMedLogo size={100} />
                            <SignaMedName width={200} />
                        </Grid>
                        <Grid item>
                            {tabValue === pLoginTab.login && <Login />}
                            {tabValue === pLoginTab.register && <Register />}
                            <WarnPassword activeTab={tabValue}/>
                        </Grid>
                        <Box className="sig_SignIn_Copyright">
                            <Copyright />
                        </Box>
                    </Grid >
                </div >
            </Grid >
        </Grid >
    );
}

/* DEBUG */
function WarnPassword(props) {
    const warning = props.activeTab === 1 ? true : false;
    
    return (
        <>
            {warning &&
                <>
                    <Typography className="sig_SignIn_WarningText" variant="body1" color="error">
                        No se recomienda utilizar la misma contraseña que usted utilice para sus cuentas de Google, esta es una versión de pruebas.
                    </Typography>
                </>}
        </>
    )
}
